import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import { store } from './store';

let conf = window.prospectusConf;

let app = new Vue({
  el: '#prospectus-app',
  components: { App },
  store: store,
  render: 
  h => h(App, {
    props: {
      config: conf
    }
  })
})


// WEBPACK FOOTER //
// ./source/js/Prospectus3Page/src/prospectuspage.js